'use strict';

angular.module('atex.dam').controller('DamPollerController', [ '$rootScope', '$resource', 'poller', 'DamDynamicQueriesService',
function($rootScope, $resource, poller, DamDynamicQueriesService) {

  var dynQueries = DamDynamicQueriesService.getDynQueries();
  
  // Define your resource object.
  var myResource = $resource('/onecms/dam/content/queryUpdate', {}, {
    postList : {
      method : 'POST'
    }
  });

  var damPoller;

  function successCallback(data) {
  }
  function errorCallback(data) {
  }
  function notifyCallback(qList) {
    if (qList.$resolved) {
      $rootScope.$broadcast("dam:dynamicUpdate", qList);
    } else {
      // Stop the poller in case of 401
      if (qList.status && qList.status === 401) {
        safeStopPolling();
      }
    }
  }

  var initPoller = function() {
    damPoller = poller.get(myResource, {
      idleDelay: 600000,
      catchError : true,
      action : 'postList',
      delay : 20000,
      argumentsArray : [ {
        'qList' : dynQueries
      } ],
      smart : true
    });

    // Update view. Most likely you only need to define notifyCallback.
    damPoller.promise.then(successCallback, errorCallback, notifyCallback);
  };

  var running = false;
  var safeStartPolling = function() {
    if (dynQueries.length>0) {
      if (!running) {
        if (!damPoller) {
          initPoller();
          console.log("Starting polling...");
        } else {
          damPoller.restart();
          console.log("Restarting polling...");
        }
      }
      running = true;
    }
  };
  var safeStopPolling = function() {
    if (running) {
      if (damPoller) {
        damPoller.stop();
        console.log("Stopping polling...");
      }
      running = false;
    }
  };

  $rootScope.$watch(function() {
    return dynQueries;
  }, function(newValue, oldValue) {
    if (newValue.length > 0) {
      safeStartPolling();
    }
    if (newValue.length <= 0) {
      safeStopPolling();
    }
  }, true);

  $rootScope.$on("dam:logout", function() {
    safeStopPolling();
  });

  $rootScope.$on("onecms:authenticationSuccess", function() {
    safeStartPolling();
  });

  $rootScope.$on("dam:toggleQueryList", function(event, panelOpened) {
    if (panelOpened) {
      safeStartPolling();
    } else {
      safeStopPolling();
    }
  });

} ]);
